import blackbaudCardIcon from './blackbaud_card_icon.svg';
import salesforceCardIcon from './salesforce_card_icon.svg';

import blackbaudLogo from './blackbaud_logo.png';
import salesforceLogo from './salesforce_logo.png';

export const logos = {
  blackbaud: blackbaudLogo,
  salesforce: salesforceLogo,
  SalesforceCRM_card: salesforceCardIcon,
  BlackbaudCRM_card: blackbaudCardIcon,
};
